import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Popup from "@/components/common/popup/Popup";

import ConsoleApp from "./ConsoleApp";
import UserApp from "./UserApp";

function App() {
    const location = useLocation();

    // 페이지 이동시 스크롤위치 초기화
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <Routes>
                <Route path="/console/*" element={<ConsoleApp />} />
                <Route path="/*" element={<UserApp />} />
            </Routes>

            {/* 팝업 */}
            <Popup />
        </>
    );
}

export default App;
